export enum CollaborationStatus {
  Ideating = 'Ideating',
  Planing = 'Planing',
  LiteratureReview = 'Literature review',
  Experimenting = 'Experimenting',
  AnalysingData = 'Analysing data',
  ResultsPublished = 'Results published',
}
